module.exports = __webpack_public_path__ + "img/banner.997c24e.png";